import { render, staticRenderFns } from "./regras.vue?vue&type=template&id=9e64b7b2&scoped=true"
import script from "./regras.vue?vue&type=script&lang=js"
export * from "./regras.vue?vue&type=script&lang=js"
import style0 from "./regras.vue?vue&type=style&index=0&id=9e64b7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e64b7b2",
  null
  
)

export default component.exports